import device from './device';

export default function getIsMobile() {
	return device.isMobile;
}
